import * as R from 'ramda'

export function unpackSafeHtml(safeHtml: any) {
  if (R.is(Object, safeHtml) && !R.isNil((<any>safeHtml).changingThisBreaksApplicationSecurity)) {
    return (<any>safeHtml).changingThisBreaksApplicationSecurity
  } else {
    return safeHtml
  }
}
